import { createStyles } from "@mantine/core";
import { colors, pxToRem } from "theme";

export const useStyles = createStyles((theme) => ({
  warning: {
    width: pxToRem[20],
    marginTop: pxToRem[6],
  },
  errorIcon: {
    color: colors.iconDestructive,
    width: pxToRem[20],
    marginTop: pxToRem[4],
  },
  error: {
    color: colors.iconDestructive,
  },
  input: {
    border: `1px solid ${colors.grey[70]}`,
    borderRadius: pxToRem[2],
    "&:focus": {
      borderColor: theme.other.primary[60],
    },
  },
}));
